<template>
    <div>

        <div>
            <p></p>
            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;"><b>配件列表</b></p>

                <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                    <el-button round @click="download">下载模板</el-button>
                </p>
                <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                    <el-upload action="#" :http-request="upload" :show-file-list="false">
                        <el-button round type="success">批量导入</el-button>
                        <span>-</span>
                    </el-upload>
                </p>

                <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                    <el-button round @click="openDialog" type="success">新增配件</el-button>
                    <span>-</span>
                </p>

                <p style="display:inline-block;line-height: 40px;margin:5px 0">
                    <el-radio-group v-model="bigTypeSearch" @input="searchByBigType">
                        <el-radio-button label="0">产品设计</el-radio-button>
                        <el-radio-button label="1">模具设计</el-radio-button>
                        <el-radio-button label="2">模芯</el-radio-button>
                        <el-radio-button label="3">模架</el-radio-button>
                        <el-radio-button label="-1">全部</el-radio-button>
                    </el-radio-group>
                </p>
            </div>

            <el-table :data="bomList" row-key="id" style="width: 100%">
                <el-table-column type="index" width="40">
                </el-table-column>
                
                <el-table-column prop="bomBigTypeDesc" label="BOM大类" min-width="10%">
                </el-table-column>
                <el-table-column prop="sparePartCode" label="配件编号" min-width="19%">
                </el-table-column>
                <el-table-column prop="sparePartName" label="配件名称" min-width="20%">
                </el-table-column>

                <el-table-column prop="maker" label="创建人" min-width="15%">
                </el-table-column>
                <el-table-column prop="createdTime" label="创建时间" min-width="11%">
                </el-table-column>

                <el-table-column prop="remark" label="备注" min-width="25%">
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="primary" round size="small">
                            更改
                        </el-button>
                        <el-button @click="deleteClick(scope.row)" type="warning" round size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-dialog title="配件详情" :visible.sync="dialogFormVisible" width="60%">
                <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">

                    <el-form-item label="BOM大类" required :label-width="formLabelWidth">
                        <el-select v-model="form.bomBigType" placeholder="请选择" style="width:220px"
                            :disabled="bigTypeDisable">
                            <el-option v-for="item in form.bigTypeList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <div style="width:350px;display: inline-block;"></div>

                    <el-form-item label="配件编号" required :label-width="formLabelWidth" prop="sparePartCode">
                        <el-input v-model="form.sparePartCode" autocomplete="off" style="width:220px"
                            :disabled="sparePartCodeDisable"></el-input>
                    </el-form-item>
                    <el-form-item label="配件名称" required :label-width="formLabelWidth" prop="sparePartName">
                        <el-input v-model="form.sparePartName" autocomplete="off" style="width:220px"></el-input>
                    </el-form-item>

                    <el-form-item label="备注" :label-width="formLabelWidth">
                        <el-input v-model="form.remark" autocomplete="off" type="textarea" style="width:570px"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addBaseBOM('ruleForm')">保 存</el-button>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
import Sortable from 'sortablejs'

export default {
    name: "BOMBaseInfo",
    data() {
        return {
            gc: 0,
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),
            statusSearch: 0,
            // orderList: [],
            dialogFormVisible: false,
            
            form: {
                id: '',
                bigTypeList: [{
                    value: 0,
                    label: '产品设计'
                }, {
                    value: 1,
                    label: '模具设计'
                }, {
                    value: 2,
                    label: '模芯'
                }, {
                    value: 3,
                    label: '模架'
                }],
                bomBigType: '',
                sparePartCode: '',
                sparePartName: '',
                // status: 0,
                maker: '',
                remark: ''
            },
            bomBigTypeDesc: '',
            bigTypeDisable: false,
            formLabelWidth: '120px',
            bomList: [],
            sparePartCodeDisable: false,
            
            rules: {
                sparePartCode: [
                    { required: true, message: '请输入配件编号', trigger: 'blur' },
                    { required: true, message: '请输入配件编号', trigger: 'change' }
                ],
                sparePartName: [
                    { required: true, message: '请输入配件名称', trigger: 'blur' },
                    { required: true, message: '请输入配件名称', trigger: 'change' }
                ]
            },
            bigTypeSearch: 0
        }
    },
    methods: {
        handleClick(row) {
            //console.log(row);
            this.form.id = row.id
            
            this.form.bomBigType = row.bomBigType
            this.form.sparePartCode = row.sparePartCode
            this.form.sparePartName = row.sparePartName
            // this.form.status = null
            this.form.remark = row.remark

            // this.sparePartCodeDisable = true
            this.bigTypeDisable = true
            this.dialogFormVisible = true
        },
        openDialog() {

            this.form.id = ''
            this.form.bomBigType = this.bigTypeSearch

            if (this.bigTypeSearch == -1) {
                this.form.bomBigType = ''
            }

            this.form.sparePartCode = ''
            this.form.sparePartName = ''
            // this.form.status = 0
            this.form.maker = this.userId
            this.form.remark = ''

            this.sparePartCodeDisable = false
            this.bigTypeDisable = false
            this.dialogFormVisible = true

        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeBaseBOM(row)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        download() {
            this.$axios({
                method: "get",
                url: "/shiro/base/bom/download",
                data: {},
                headers: {
                    token: this.token
                },
                responseType: 'arraybuffer'
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                let objectUrl = result.config.url
                const blob = new Blob([data], {
                    type: 'application/vnd.ms-excel;charset=utf-8'
                })

                objectUrl = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = objectUrl

                a.download = "BOM配件资料导入模板.xlsx"
                a.click()
                a.remove()
                URL.revokeObjectURL(objectUrl)
            })
        },
        upload(f) {
            // console.log(f)
            const form = new FormData()
            form.append('file', f.file)
            form.append('maker', this.userId)
            form.append('companyId', this.companyId)
            this.$axios({
                method: "post",
                url: "/shiro/base/bom/upload",
                data: form,
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data
                this.getAllBaseBOM(this.bigTypeSearch)
            })
        },
        searchByBigType(val) {
            // console.log('val')
            // console.log(val)
            // console.log(parseInt(val))

            this.bigTypeSearch = parseInt(val)
            this.getAllBaseBOM(this.bigTypeSearch)

        },
        addBaseBOM(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // alert('submit!');
                    this.$axios({
                        method: "post",
                        url: "/shiro/base/bom/add",
                        data: {
                            id: this.form.id,
                            bomBigType: this.form.bomBigType,
                            sparePartCode: this.form.sparePartCode,
                            sparePartName: this.form.sparePartName,
                            maker: this.form.maker,
                            remark: this.form.remark,
                            companyId: this.companyId
                        }, headers: {
                            token: this.token
                        }
                    }).then(result => {
                        const data = result.data

                        if (data.status != 200) {
                            this.$message({
                                type: 'info',
                                message: data.msg
                            })
                            return
                        }

                        this.dialogFormVisible = false
                        this.getAllBaseBOM(this.bigTypeSearch)
                    })
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });

        },
        getAllBaseBOM(val) {
            this.$axios({
                method: "post",
                url: "/shiro/base/bom/getAll",
                data: {
                    bomBigType: val,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.bomList = data.data
                for (let i in this.bomList) {

                    this.bomList[i].createdTime = this.$moment(this.bomList[i].createdTime).format("YYYY-MM-DD")

                    if (this.bomList[i].bomBigType == 0) {
                        this.bomList[i].bomBigTypeDesc = '产品设计'
                    } else if (this.bomList[i].bomBigType == 1) {
                        this.bomList[i].bomBigTypeDesc = '模具设计'
                    } else if (this.bomList[i].bomBigType == 2) {
                        this.bomList[i].bomBigTypeDesc = '模芯'
                    } else {
                        this.bomList[i].bomBigTypeDesc = '模架'
                    }
                }
            })
        },
        removeBaseBOM(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/base/bom/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.getAllBaseBOM(this.bigTypeSearch)
            })
        },
        //行拖拽
        rowDrop() {
            const tbodys=document.querySelectorAll('.el-table__body tbody')//[8]
            // console.log(tbodys)

            const tbody = document.body.querySelector('.el-table__body tbody')
            // console.log('tbody')
            // console.log(tbody)

            const _this = this
            // console.log('_this')
            // console.log(_this)


            Sortable.create(tbody, {
                onEnd({ newIndex, oldIndex }) {
                    if (newIndex == oldIndex) return

                    _this.bomList.splice(newIndex, 0, _this.bomList.splice(oldIndex, 1)[0])

                    var newArray = _this.bomList.slice(0)
                    // console.log('newArray')
                    // console.log(newArray)

                    _this.bomList = []

                    _this.$nextTick(function () {
                        _this.bomList = newArray

                        this.sort(newArray)
                    })

                    

                }
            })

        },
        sort(val) {
            // console.log('sort()')
            const baseBOMInfoVOList=[]
            if(val.length>0){
                
                for(let i in val){
                    // moldBOMVOList.push({id:val[i].id,bomSort:val[i].bomSort})
                    delete val[i].bomBigTypeDesc
                    // delete val[i].status
                }
                // console.log('baseBOMInfoVOList')
                // console.log(baseBOMInfoVOList)
            }
            // console.log('newVal')
            // console.log(val)

            this.$axios({
                method: "post",
                url: "/shiro/base/bom/sort",
                data: {
                    baseBOMInfoVOList:val,
                    companyId:this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }
                
            })
        },
    },
    mounted() {
        // 阻止默认行为
        document.body.ondrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };
        this.rowDrop()//行拖拽

        // this.getAllOrder(this.statusSearch)
        this.getAllBaseBOM(this.bigTypeSearch)

    },
    updated() {
        // var checkBoxEle = document.getElementsByClassName("el-checkbox")
        //console.log('ududud')
        //console.log(checkColumnEle[0])
        // checkBoxEle[0].innerHTML = ''
    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}
</style>